import { Country } from '@/helpers/conf';
import { MediaType } from '@/helpers/enums';
import type { IHeadlinePromoPageConfig } from '@/modules/promotions/templates/HeadlinePromoTemplate/helpers';

const LVLS_IMAGE_PATH = '/headline-promo/oktoberfest';

const getPromoImg = (path: string) => `${LVLS_IMAGE_PATH}/${path}.webp`;

const BG_STAGE_0 = {
  desk: getPromoImg('bg_3_desk'),
  mob: getPromoImg('bg_3_mob'),
};
const BG_STAGE_1 = {
  desk: getPromoImg('bg_2_desk'),
  mob: getPromoImg('bg_2_mob'),
};
const BG_STAGE_2 = {
  desk: getPromoImg('bg_1_desk'),
  mob: getPromoImg('bg_1_mob'),
};

const CHARACTER_IMAGE_STAGE_0 = {
  desk: getPromoImg('character_1'),
  mob: getPromoImg('character_1'),
};

const CHARACTER_IMAGE_STAGE_1 = {
  desk: getPromoImg('character_2'),
  mob: getPromoImg('character_2'),
};

const CHARACTER_IMAGE_STAGE_2 = {
  desk: getPromoImg('character_3'),
  mob: getPromoImg('character_3'),
};

const GLOW_COLOR = '247, 159, 55';
const GLOW_END_OPACITY = 0.8;

export const OKTOBERFEST_CONFIG: IHeadlinePromoPageConfig = {
  promoKey: 'oktoberfest',
  route: '/oktoberfest',
  namespace: 'oktoberfest',
  disableAnimations: true,
  useFullNameAsGroupId: true,
  dateFormat: 'dd.MM',
  hideHowToGamesCountLabel: true,
  progressBarVariant: 'pill',
  hideHowToDescription: false,
  faqBgImage: `${LVLS_IMAGE_PATH}/faq_decor.webp`,
  ctaAlwaysDeposit: true,
  allowedCountries: [Country.Germany],
  levelsMobileBreakpoint: MediaType.MOBILE_S,

  cardHud: {
    kind: 'image',
    src: `${LVLS_IMAGE_PATH}/hud_default.webp`,
  },

  levelsConfig: [
    {
      name: 'Oktoberfest Starter',
      image: getPromoImg('lvl_1'),
      lockedImage: getPromoImg('lvl_1'),
      promoRewardType: 'deps',
      depsCount: { 0: 0, 25: 1, 75: 2, 100: 3 },
      reward: { kind: 'freespins', count: 20 },
      rewardGroupKey: 'octoberfest_l1_reward',
      bg: BG_STAGE_0,
      glowColor: GLOW_COLOR,
      glowEndOpacity: GLOW_END_OPACITY,
      characterImage: CHARACTER_IMAGE_STAGE_0,
    },
    {
      name: 'Bavarian Explorer',
      image: getPromoImg('lvl_2'),
      lockedImage: getPromoImg('lvl_2'),
      promoRewardType: 'deps',
      depsCount: { 0: 3, 25: 4, 75: 5, 100: 6 },
      reward: { kind: 'freespins', count: 30 },
      rewardGroupKey: 'octoberfest_l2_reward',
      bg: BG_STAGE_0,
      glowColor: GLOW_COLOR,
      glowEndOpacity: GLOW_END_OPACITY,
      characterImage: CHARACTER_IMAGE_STAGE_0,
    },
    {
      name: 'Festmusik Fan',
      image: getPromoImg('lvl_3'),
      lockedImage: getPromoImg('lvl_3'),
      promoRewardType: 'deps',
      depsCount: { 0: 6, 25: 7, 75: 8, 100: 9 },
      reward: { kind: 'freespins', count: 40 },
      rewardGroupKey: 'octoberfest_l3_reward',
      bg: BG_STAGE_0,
      glowColor: GLOW_COLOR,
      glowEndOpacity: GLOW_END_OPACITY,
      characterImage: CHARACTER_IMAGE_STAGE_0,
    },
    {
      name: 'Beer Garden Regular',
      image: getPromoImg('lvl_4'),
      lockedImage: getPromoImg('lvl_4'),
      promoRewardType: 'deps',
      depsCount: { 0: 9, 25: 10, 50: 12, 75: 13, 100: 14 },
      reward: { kind: 'freespins', count: 50 },
      rewardGroupKey: 'octoberfest_l4_reward',
      bg: BG_STAGE_1,
      glowColor: GLOW_COLOR,
      glowEndOpacity: GLOW_END_OPACITY,
      characterImage: CHARACTER_IMAGE_STAGE_1,
    },
    {
      name: 'Festzelt Insider',
      image: getPromoImg('lvl_5'),
      lockedImage: getPromoImg('lvl_5'),
      promoRewardType: 'deps',
      depsCount: { 0: 14, 25: 15, 50: 17, 75: 18, 100: 19 },
      reward: { kind: 'freespins', count: 75 },
      rewardGroupKey: 'octoberfest_l5_reward',
      bg: BG_STAGE_1,
      glowColor: GLOW_COLOR,
      glowEndOpacity: GLOW_END_OPACITY,
      characterImage: CHARACTER_IMAGE_STAGE_1,
    },
    {
      name: 'Bavarian Legend',
      image: getPromoImg('lvl_6'),
      lockedImage: getPromoImg('lvl_6'),
      promoRewardType: 'deps',
      depsCount: { 0: 19, 25: 22, 50: 25, 75: 28, 100: 30 },
      reward: { kind: 'bonus', amount: 20 },
      rewardGroupKey: 'octoberfest_l6_reward',
      bg: BG_STAGE_1,
      glowColor: GLOW_COLOR,
      glowEndOpacity: GLOW_END_OPACITY,
      characterImage: CHARACTER_IMAGE_STAGE_1,
    },
    {
      name: 'Oktoberfest Champion',
      image: getPromoImg('lvl_7'),
      lockedImage: getPromoImg('lvl_7'),
      promoRewardType: 'deps',
      depsCount: { 0: 30, 25: 35, 50: 40, 75: 45, 100: 50 },
      reward: {
        kind: 'bonus',
        amount: 75,
        labelKey: 'missionLevels.card.megaBonus',
      },
      rewardGroupKey: 'octoberfest_l7_reward',
      bg: BG_STAGE_2,
      glowColor: GLOW_COLOR,
      glowEndOpacity: GLOW_END_OPACITY,
      characterImage: CHARACTER_IMAGE_STAGE_2,
    },
  ],
};
